/**
 * Pure helper shared by the public package page: decide whether a failed
 * package-run request means the visitor's short-lived run grant (or the run
 * itself) has expired / is no longer authorized, so the page can bounce back to
 * the OTP step and let the visitor re-verify (which RESUMES the same run
 * server-side).
 *
 * The API surfaces these as opaque `{ success:false, error }` envelopes (no
 * status code), so we match on the known error strings emitted by
 * `functions/forms/package-runs.ts` and the submit run-grant gate:
 *   - 401 'Authentication required' / 'Invalid or expired token'
 *   - 403 'Access denied'
 *   - 410 'This form link has expired'
 */
export function isSessionExpiredError(error: string | null | undefined): boolean {
  if (!error) return false;
  return /expired|authentication required|access denied/i.test(error);
}
